<template>
    <div class="page my-list-order">

        <div class="live-list-section">
            <van-row @click="$router.push({'name':'live-detail',params:{id:item.id}})" v-for="item in list" :key="item.id">
                <div class="live-list-section-box">
                    <div class="live-list-section-left">
                        <img class="live-list-section-left-img" :src="item.cover_img">
                        <img v-if="item.live_status==0" class="live-list-section-left-zl" src="/static/img/live/icon_list_tag_live_count_down.svg" alt="">
                        <img v-if="item.live_status==1" class="live-list-section-left-zl" src="/static/img/live/icon_list_tag_live_process.svg" alt="">
                        <img v-if="item.live_status==2" class="live-list-section-left-zl" src="/static/img/live/icon_list_tag_live_history.svg" alt="">
                    </div>
                    <div class="live-list-section-right">
                        <div class="live-list-section-right-title">{{item.title}}</div>
                        <div class="live-list-section-right-detail">{{item.start_at}}
                            <span class="live-list-section-right-detail-join">加入</span>
                        </div>
                    </div>
                </div>
            </van-row>
            <van-empty description="没有更多了" v-if="list.length == 0" />
        </div>
    </div>
</template>

<script>
    import Interface from "@/util/interface"
    export default {
        name: 'home',
        data() {
            return {
                value: "",
                active: 1,
                list:[],
                recommend:[],
                articles:[],
                category_id : 0,
                categories:[
                    {name:'课程'},
                    {name:'直播'},
                    {name:'资讯'},
                    {name:'短视频'}
                ],
                forecast:[]
            }
        },
        methods: {
            fetch(scene) {
                if (scene === 'list-order') {
                    Interface.getData('get',Interface.user.appointment,{pageSize:999}).then((res)=>{
                        this.list = res.data.list
                    })
                }
            },
            changeCategory(){
                console.log(this.category_id)
            }
        },
        created() {
            this.fetch('list-order')
            Interface.getShareInfo(this,"","","")
        },
    }
</script>

<style lang="scss">
    @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/my/list_order/index.vue